import m, {Vnode} from "mithril";
import {Questionary} from "../../../../model/questionary";

export default class MessageBox {

    /**
     * Expect message like "uploadSuccess" (will be translated) or "Upload successful" or "<b>Upload successful</b>"
     */
    constructor(
        public readonly questionary: Questionary,
        public message: string,
        public type: "accent"|"success"|"danger"|"warning"|"info" = "info",
        public icon: string|undefined,
    ) {}

    private viewIcon(): Vnode|null {
        if (this.icon === undefined) {
            return null;
        }
        return m(`i.icon.${this.type}.icon-${this.icon}`);
    }

    public view(): Vnode {
        return m(".message-box.message-box-"+this.type, {}, [
            this.viewIcon(),
            m("p", {}, m.trust(this.questionary.renderText( this.questionary.messages.get(this.message))) ),
        ]);
    }
}
